import Model from "~/models/_Model";

export default class Room extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "rooms";
  }

  primaryKey() {
    return "ROOM_ID";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  get display_name() {
    return this.DESCRIPTION
      ? `${this.ROOM_ID.trim()}: ${this.DESCRIPTION}`
      : this.ROOM_ID.trim();
  }
}
